import { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { RangeControl, SelectControl, TextControl } from '@wordpress/components';
import { orderByOpt, orderOpt } from '../../utils/options';
import { Label } from '../../../../Components';
import Row from '../../settings/Components/Row/Row';
import Column from '../../settings/Components/Column/Column';

const QueryPanel = ({ setData, data }) => {
    const { route = '', categories = [], limit, order_by, order } = data;
    const [allCategories, setAllCategories] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetch(`${wcCategories?.ajaxUrl}?action=bpwsnb_get_category&nonce=${wcCategories?.nonce}`).then(res => res.json()).then(async (responseData) => {
                    setAllCategories(responseData?.data);
                });
            } catch (error) {
                console.error('Error:', error);
            }
        }
        fetchData();
    }, []);

    if (!allCategories) {
        return null;
    }

    const categoriesOpt = allCategories?.map((category) => {
        return { label: category.name, value: category.id }
    });

    const origin = window.location.origin;

    return (
        <div className='settingArea'>
            <div className="route">
                <div className="title">{__('Route', 'bpwsnb')}</div>
                <TextControl className='disable' label={__('', '')} value={origin} Disabled />
                <TextControl label={__('', '')} value={route} onChange={val => setData({ ...data, route: val })} />
                <a target='__blank' href={`${origin}/${route}`}>{__('Page View', 'bpwsnb')}</a>
            </div>

            <Row gap={20}>
                <Column span={6}>
                    <SelectControl className='' label={__('Categories', 'bpwsnb')} labelPosition='side' options={[{ label: 'Select', value: '' }, ...categoriesOpt]} value={categories} onChange={(val) => { setData({ ...data, categories: [val] }) }} />
                </Column>
                <Column span={6}>
                    <div>
                        <Label className='mt5'>{__('Products Limit:', 'bpwsnb')}</Label>
                        <RangeControl value={limit} onChange={val => setData({ ...data, limit: val })} min={-1} max={60} step={1} />
                    </div>
                </Column>

            </Row>
            <Row>
                <Column span={6}>
                    <SelectControl className='' label={__('Order by', 'bpwsnb')} labelPosition='side' options={orderByOpt} value={order_by} onChange={(val) => { setData({ ...data, order_by: val }) }} />
                </Column>
                <Column span={6}>
                    <SelectControl className='' label={__('Order', 'bpwsnb')} labelPosition='side' options={orderOpt} value={order} onChange={(val) => { setData({ ...data, order: val }) }} />
                </Column>
            </Row>
        </div>
    );
};
export default QueryPanel;
